'use client'

import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { ArrowLeftIcon } from "lucide-react"
import { useRouter } from 'next/navigation'

function BackButton({ className, ...props }: React.ComponentProps<typeof Button>) {
    const router = useRouter()
  
    return (
        <Button
            onClick={() => router.back()}
            variant="link"
            className={cn("gap-1 text-white hover:no-underline my-4", className)}
            {...props}
        >
            <ArrowLeftIcon /> Voltar
        </Button>
    )
}

function BackButtonAdmin({
    icon = true,
    className,
    ...props
}: {
    icon?: boolean;
} & React.ComponentProps<typeof Button>) {
    const router = useRouter()

    return (
        <Button
            onClick={() => router.back()}
            variant="link"
            className={cn("flex items-center transition-opacity hover:opacity-70 text-lg font-semibold text-puc-blue-primary", className)}
            {...props}
        >
            {icon && <ArrowLeftIcon />}
            Voltar
        </Button>
    )
}


export { BackButton, BackButtonAdmin }